import React from 'react';
import { QuoteBlock } from '../components/QuoteBlock';
import { BlurredBadge } from '../components/BlurredBadge';
export type PostData = {
  id: number;
  avatar: {
    letter: string;
    color: 'blue' | 'gray' | 'green' | 'amber' | 'red' | 'purple' | 'teal' | 'brown';
  };
  username: string;
  role: string;
  isStammgast?: boolean;
  stats: {
    joined: string;
    posts: number;
  };
  datetime: string;
  title?: string;
  content: React.ReactNode;
};
export const forumPosts: PostData[] = [{
  id: 1,
  avatar: {
    letter: 'T',
    color: 'blue'
  },
  username: 'Typ_aus_Sonneberg',
  role: 'Mitglied',
  stats: {
    joined: '14.07.2019',
    posts: 203
  },
  datetime: '26.04.2026, 09:14',
  title: 'Männer ab 45: Das nächtliche Aufstehen ist kein Zufall — ignoriert das nicht',
  content: <>
        <p className="text-[13.5px]" data-id="element-162">Hallo zusammen.</p>
        <p className="text-[13.5px]" data-id="element-163">
          Ich weiß nicht mal genau warum ich das hier schreibe. Vielleicht weil
          ich's niemandem in meinem echten Leben sagen kann. Vielleicht weil ich
          Antworten brauche. Vielleicht beides.
        </p>
        <p className="text-[13.5px]" data-id="element-164">
          Ich bin 45, und seit zwei Jahren stehe ich jede Nacht auf. Einmal,
          manchmal zweimal. Immer dasselbe — aufwachen, raus, zurück ins Bett,
          Augen zu, und dann liegt man da und schläft nicht mehr richtig ein.
          Irgendwann klingelt der Wecker und man fühlt sich als hätte man gar
          nicht geschlafen.
        </p>
        <p className="text-[13.5px]" data-id="element-165">
          Mit 43 hat's angefangen. Einmal pro Nacht — dachte ich, das ist halt
          so. Man wird älter. Hab's nicht mal erwähnt, nicht meiner Frau, nicht
          dem Arzt. Wozu auch, es hat ja nicht wehgetan.
        </p>
        <p className="text-[13.5px]" data-id="element-166">Das war mein Fehler.</p>
        <p data-id="element-167">
          Was ich damals nicht kapiert hab: Ich hab seit zwei Jahren nicht mehr
          wirklich durchgeschlafen. Und das merkst du nicht sofort. Du merkst es
          nach Monaten. Nach Jahren. Wenn du morgens aufstehst und schon fertig
          bist bevor der Tag angefangen hat.
        </p>
        <p data-id="element-168">
          Auf der Arbeit funktioniere ich — aber ich funktioniere nur noch. Mein
          Chef hat mir letzte Woche gesagt, ich wirke abwesend. Vor zwei Jahren
          war ich derjenige der die Meetings angetrieben hat. Jetzt nicke ich
          nur noch.
        </p>
        <p data-id="element-169">
          Zuhause ist es nicht besser. Ich hab keine Energie mehr — für nichts.
          Abends nach dem Essen bin ich weg. Augen auf, Kopf weg. Meine Frau
          redet, ich nick. Irgendwann hat sie aufgehört zu reden.
        </p>
        <p data-id="element-170">
          Ich hab angefangen mehr Bier zu trinken — dachte, hilft beim
          Einschlafen. Hilft es nicht. Hab eine Woche aufgehört, war minimal
          besser, aber das Aufstehen blieb. Nach zehn Tagen hab ich wieder
          angefangen. Ich hab zugenommen. Sport hab ich irgendwann einfach
          weggelassen. Zu müde.
        </p>
        <p data-id="element-171">Und dann kamen die Momente die ich nicht vergesse.</p>
        <p data-id="element-172">
          Mein Sohn ist 16. Vor ein paar Wochen hab ich ihn angeschrien — wegen
          nichts, irgendwas nicht aufgeräumt. Er hat mich angeschaut, ist
          wortlos in sein Zimmer gegangen, Tür zu. Ich stand im Flur und wusste
          selbst nicht warum ich so ausgerastet bin. Später hab ich gehört wie
          meine Frau zu ihm sagt: der Papa ist einfach müde, nicht so gemeint.
          Das ist jetzt normal geworden. Dass sie meinen Sohn vor mir erklärt.
          Wir waren mal eng, er und ich. Jetzt reden wir kaum noch.
        </p>
        <p data-id="element-173">
          Und meine Frau. Wir sind seit 15 Jahren zusammen. Seit ein paar
          Monaten merke ich Dinge — neues Parfüm, neue Klamotten, öfter mal
          abends weg, das Handy liegt nicht mehr rum. Ich sag das nicht laut,
          ich will das nicht laut sagen. Aber ich lieg nachts neben ihr und sie
          dreht sich weg und ich denk: wann haben wir eigentlich das letzte Mal
          wirklich miteinander geredet? Nicht über den Sohn, nicht über Einkäufe
          — wirklich. Ich weiß es nicht mehr.
        </p>
        <p data-id="element-174">
          Ich bin ein anderer Mensch geworden. Nicht auf einmal — sondern Stück
          für Stück, so langsam dass ich's selbst nicht gemerkt hab. Und alles
          hat angefangen mit dieser einen Kleinigkeit mit 43. Einmal pro Nacht
          aufstehen. Dachte, das ist halt so.
        </p>
        <p data-id="element-175">Ich will nicht so werden. Ich will nicht dieser Mann sein.</p>
        <p data-id="element-176">
          Hat jemand von euch dasselbe? Weiß jemand was das ist, warum das
          passiert, was man dagegen tun kann? Ich bin wirklich am Ende. Jeder
          Rat ist willkommen.
        </p>
        <p style={{
      marginTop: '0.75rem'
    }} data-id="element-177">
          Thomas
        </p>
      </>
}, {
  id: 2,
  avatar: {
    letter: 'P',
    color: 'gray'
  },
  username: 'Panda1981',
  role: 'Mitglied',
  stats: {
    joined: '03.02.2021',
    posts: 89
  },
  datetime: '26.04.2026, 10:44',
  content: <>
        <p data-id="element-178">
          Thomas, ich hab deinen Post dreimal gelesen. Jedes Mal mit dem Gefühl
          dass du über mich schreibst.
        </p>
        <p data-id="element-179">
          Ich bin 45. Bei mir geht das seit knapp drei Jahren so. Meine Frau
          schläft seit einem Jahr im Gästezimmer — wir haben das praktisch
          genannt. Es ist nicht praktisch. Es ist einfach nur traurig.
        </p>
        <p data-id="element-180">
          Ich hab keine Antwort für dich. Aber ich bin froh dass du das
          geschrieben hast. Ich dachte immer, das ist nur bei mir so.
        </p>
      </>
}, {
  id: 3,
  avatar: {
    letter: 'G',
    color: 'green'
  },
  username: 'Grillmeister_Franken',
  role: 'Mitglied',
  stats: {
    joined: '07.08.2022',
    posts: 57
  },
  datetime: '26.04.2026, 11:58',
  content: <>
        <p data-id="element-181">
          47 hier. Seit zwei Jahren dasselbe. Hab meinem Arzt davon erzählt —
          der hat gesagt ich soll abends weniger trinken. Das war's.
        </p>
        <p data-id="element-182">
          Thomas, den Teil mit dem Sohn — der hat mich erwischt. Ich mach das
          auch. Meine Frau sagt nichts mehr dazu. Das ist fast schlimmer als
          wenn sie was sagen würde.
        </p>
        <p data-id="element-183">
          Ich will auch wissen was dahintersteckt. Und ob man da wirklich was
          machen kann.
        </p>
      </>
}, {
  id: 4,
  avatar: {
    letter: 'K',
    color: 'amber'
  },
  username: 'Klaus_Freiburg',
  role: 'Mitglied',
  isStammgast: true,
  stats: {
    joined: '09.05.2019',
    posts: 378
  },
  datetime: '26.04.2026, 13:20',
  content: <>
        <p data-id="element-184">
          Thomas, Panda1981, Grillmeister — ich les das hier und erkenn jeden
          von euch. Ich bin 49, hab das vor ein paar Jahren selbst durchgemacht.
          Zum Glück früh genug hingeschaut. Deshalb schreib ich jetzt.
        </p>
        <p data-id="element-185">
          Ich erklär euch was da passiert. Nicht um klug zu klingen — sondern
          weil mir das damals niemand erklärt hat und ich zu lange im Dunkeln
          getappt bin.
        </p>
        <p data-id="element-186">
          Ab etwa 40 beginnt sich die Prostata bei fast jedem Mann langsam zu
          vergrößern. Das ist keine Krankheit — das ist normale Biologie, nennt
          sich Gutartige Prostatavergrößerung. Die Prostata liegt direkt unter
          der Blase und umschließt die Harnröhre. Wenn sie wächst, drückt sie
          auf die Blase — und die Blase meldet sich früher. Nachts. Deshalb das
          Aufstehen. Kein Zufall, reine Mechanik.
        </p>
        <p data-id="element-187">
          Das Heimtückische: Am Anfang ist es einmal pro Nacht. Kaum spürbar.
          Und weil es nicht wehtut, ignoriert man es. Aber die Prostata wächst
          weiter — still, langsam, ohne Schmerz. Und irgendwann kippt es.
        </p>
        <p data-id="element-188">
          Thomas, du bist 45 und machst das seit zwei Jahren. Noch handhabbar —
          aber nicht mehr lange wenn du nichts tust. Panda1981, du auch — drei
          Jahre sind nicht wenig, schau bald hin.
        </p>
        <p data-id="element-189">
          Für alle die noch am Anfang sind: Pflanzliche Nahrungsergänzungsmittel
          können bei ersten Anzeichen einen echten Unterschied machen. Wenn das
          nicht reicht — dann zum Arzt. Aber wartet nicht bis der Körper euch
          zwingt.
        </p>
      </>
}, {
  id: 5,
  avatar: {
    letter: 'T',
    color: 'blue'
  },
  username: 'Typ_aus_Sonneberg',
  role: 'Mitglied',
  stats: {
    joined: '14.07.2019',
    posts: 203
  },
  datetime: '26.04.2026, 14:05',
  content: <>
        <QuoteBlock who="Klaus_Freiburg schrieb:" data-id="element-190">
          Pflanzliche Nahrungsergänzungsmittel können in frühen Stadien einen
          echten Unterschied machen.
        </QuoteBlock>
        <p data-id="element-191">
          Klaus, danke. Ernsthaft. Das ist das erste Mal dass mir jemand
          wirklich erklärt warum das passiert — nicht trinken Sie abends
          weniger, sondern wirklich erklärt.
        </p>
        <p data-id="element-192">
          Was hast du konkret gemacht? Ich will nicht noch zwei weitere Jahre so
          leben.
        </p>
      </>
}, {
  id: 6,
  avatar: {
    letter: 'G',
    color: 'green'
  },
  username: 'Grillmeister_Franken',
  role: 'Mitglied',
  stats: {
    joined: '07.08.2022',
    posts: 57
  },
  datetime: '26.04.2026, 14:33',
  content: <>
        <p data-id="element-193">
          Klaus, ich schließ mich Thomas an. Was nimmst du? Ich vertrau dem was
          du hier schreibst mehr als allem was ich bisher gegoogelt hab.
        </p>
      </>
}, {
  id: 7,
  avatar: {
    letter: 'A',
    color: 'purple'
  },
  username: 'AutobahnPilot57',
  role: 'Mitglied',
  stats: {
    joined: '22.04.2020',
    posts: 134
  },
  datetime: '26.04.2026, 14:58',
  content: <>
        <p data-id="element-194">
          48 hier, Außendienst. Schlaf seit einem Jahr in der Mittagspause im
          Auto auf dem Parkplatz. Kollegen denken ich telefoniere.
        </p>
        <p data-id="element-195">Klaus, bitte — was hat bei dir funktioniert?</p>
      </>
}, {
  id: 8,
  avatar: {
    letter: 'K',
    color: 'amber'
  },
  username: 'Klaus_Freiburg',
  role: 'Mitglied',
  isStammgast: true,
  stats: {
    joined: '09.05.2019',
    posts: 378
  },
  datetime: '26.04.2026, 16:50',
  content: <>
        <p data-id="element-196">
          Thomas, Grillmeister, AutobahnPilot — ich erklär's. Aber ich erklär
          auch warum ich erst Lehrgeld zahlen musste bevor ich das Richtige
          gefunden hab.
        </p>
        <p data-id="element-197">
          Der bekannteste Wirkstoff für die Prostata ist Sägepalme — Saw
          Palmetto. Hat in Studien gezeigt dass er helfen kann wenn man ihn
          regelmäßig nimmt. Klingt einfach. Ist es aber nicht — und da liegt der
          Haken.
        </p>
        <p data-id="element-198">
          Ich hab zuerst zwei Produkte von Amazon gekauft. Günstig, viele
          Sterne, große Versprechen. Beide haben rein gar nichts gebracht. Geld
          weg, Wochen verloren.
        </p>
        <p data-id="element-199">
          Dann hab ich angefangen zu verstehen warum. Die meisten Hersteller
          schreiben auf ihre Produkte nur die Milligramm-Zahl — 300 mg
          Sägepalme, 500 mg, 600 mg. Klingt nach viel. Aber die Milligramm
          allein sagen überhaupt nichts über die Wirksamkeit. Was zählt ist die
          Standardisierung — das ist der Prozentsatz in Klammern auf der
          Verpackung, zum Beispiel (30% Fettsäuren). Das ist der Anteil des
          echten Wirkstoffs.
        </p>
        <p data-id="element-200">
          Warum schreiben die meisten Hersteller nur die Milligramm und nicht
          die Standardisierung? Weil ihre Standardisierung so niedrig ist, dass
          sie sie lieber verstecken. Unter 30% — das ist meiner Meinung nach
          Füllmaterial. Man kauft eine beeindruckende Zahl auf der Packung und
          kriegt dafür überwiegend wertloses Pflanzenpulver.
        </p>
        <p data-id="element-201">
          Ich hab dann gezielt nach Produkten gesucht die die Standardisierung
          transparent ausweisen und über 30% liegen. Dazu kommt: Sucht nach
          einer Formel, die Hand und Fuß hat. Viele Hersteller mischen einfach
          nur ein bisschen Zink und Selen rein, damit sie legal „für die
          Männergesundheit“ draufschreiben dürfen. Aber das ist oft nur
          Marketing-Quatsch. Diese Mineralien können sich im Darm mit den
          Pflanzenextrakten verhaken und blockieren die Aufnahme. Dann landet
          das Zeug im Klo statt im Körper. Setzt lieber auf reine, hochdosierte
          Pflanzenpower, die auch wirklich ankommt.
        </p>
        <p data-id="element-202">
          Nach ein paar Wochen mit dem richtigen Produkt hab ich gemerkt dass
          ich ruhiger schlafe. Weniger Unterbrechungen. Morgens klarer im Kopf.
          Das war vor zwei Jahren — seitdem schläft meine Frau wieder neben mir.
        </p>
      </>
}, {
  id: 9,
  avatar: {
    letter: 'P',
    color: 'gray'
  },
  username: 'Panda1981',
  role: 'Mitglied',
  stats: {
    joined: '03.02.2021',
    posts: 89
  },
  datetime: '26.04.2026, 17:38',
  content: <>
        <p data-id="element-203">
          Klaus, das mit den Prozenten in Klammern — ich hab nie gewusst worauf
          ich schauen soll. Jetzt ergibt das Sinn warum das Zeug das ich mal
          probiert hab nichts gebracht hat. Stand wahrscheinlich gar keine
          Standardisierung drauf.
        </p>
        <p data-id="element-204">Was nimmst du konkret, wenn ich fragen darf?</p>
      </>
}, {
  id: 10,
  avatar: {
    letter: 'K',
    color: 'amber'
  },
  username: 'Klaus_Freiburg',
  role: 'Mitglied',
  isStammgast: true,
  stats: {
    joined: '09.05.2019',
    posts: 378
  },
  datetime: '26.04.2026, 19:15',
  content: <>
        <QuoteBlock who="Panda1981 schrieb:" data-id="element-205">Was nimmst du konkret?</QuoteBlock>
        <p data-id="element-206">
          Ich nehm seit zwei Jahren <BlurredBadge data-id="element-207">NachTon</BlurredBadge>.
          Deutsches Produkt, ordentliche Qualität.
        </p>
        <p data-id="element-208">
          45% Standardisierung bei der Sägepalme — steht transparent auf der
          Verpackung, kein Versteckspiel. Dazu kommen weitere natürliche
          Extrakte, die die Wirkung der Sägepalme verstärken.
        </p>
        <p data-id="element-209">
          Und ehrlich gesagt — für das was man bekommt ist der Preis absolut in
          Ordnung. Ich hab vorher für nutzloses Zeug mehr ausgegeben. Hier
          zahlst du einmal vernünftig und kriegst dafür ein Produkt das wirklich
          was taugt. Bestes Preis-Leistungs-Verhältnis das ich in dem Bereich
          gefunden hab.
        </p>
        <p data-id="element-210">
          Thomas, Grillmeister, AutobahnPilot — ihr seid noch nicht zu spät
          dran. Aber wartet nicht noch ein Jahr.
        </p>
      </>
}, {
  id: 11,
  avatar: {
    letter: 'N',
    color: 'red'
  },
  username: 'NachtfalterHH',
  role: 'Mitglied',
  stats: {
    joined: '19.11.2022',
    posts: 441
  },
  datetime: '26.04.2026, 20:22',
  content: <>
        <QuoteBlock who="Klaus_Freiburg schrieb:" data-id="element-211">
          Ich nehm seit zwei Jahren <BlurredBadge data-id="element-212">NachTon</BlurredBadge>.
          Deutsches Produkt, ordentliche Qualität... Bestes
          Preis-Leistungs-Verhältnis das ich in dem Bereich gefunden hab.
        </QuoteBlock>
        <p data-id="element-213">
          Ich will niemandem zu nahe treten — aber das klingt jetzt doch sehr
          nach Werbung. Produktname, Standardisierungsprozente auswendig, alles
          sehr rund formuliert. Sowas hab ich schon öfter in Foren gesehen.
        </p>
      </>
}, {
  id: 12,
  avatar: {
    letter: 'G',
    color: 'green'
  },
  username: 'Grillmeister_Franken',
  role: 'Mitglied',
  stats: {
    joined: '07.08.2022',
    posts: 57
  },
  datetime: '26.04.2026, 20:41',
  content: <>
        <p data-id="element-214">
          Ich kann es nicht finden. Ich lebe in der Schweiz, daher werden mir
          deutsche Produkte nicht angezeigt.
        </p>
      </>
}, {
  id: 13,
  avatar: {
    letter: 'A',
    color: 'purple'
  },
  username: 'AutobahnPilot57',
  role: 'Mitglied',
  stats: {
    joined: '22.04.2020',
    posts: 134
  },
  datetime: '26.04.2026, 20:58',
  content: <>
        <QuoteBlock who="Grillmeister_Franken schrieb:" data-id="element-215">
          Kann man das Produkt auch hier irgendwo bestellen?
        </QuoteBlock>
        <p data-id="element-216">
          Hab's gefunden, hier:{' '}
          <BlurredBadge href="https://nachton.de/products/nachton?utm_source=facebook&utm_medium=paid&utm_campaign=nachton_de&utm_content=viwe_forum" data-id="element-217">
            https://nachton.de/products/nachton
          </BlurredBadge>{' '}
          — sieht ernst aus.
        </p>
      </>
}, {
  id: 14,
  avatar: {
    letter: 'K',
    color: 'amber'
  },
  username: 'Klaus_Freiburg',
  role: 'Mitglied',
  isStammgast: true,
  stats: {
    joined: '09.05.2019',
    posts: 378
  },
  datetime: '26.04.2026, 21:10',
  content: <>
        <QuoteBlock who="NachtfalterHH schrieb:" data-id="element-218">
          klingt sehr nach Werbung
        </QuoteBlock>
        <p data-id="element-219">
          NachtfalterHH, kann ich verstehen. Ich hätte das vor drei Jahren auch
          so gesehen.
        </p>
        <p data-id="element-220">
          Die Zahlen kenn ich auswendig weil ich nach dem zweiten nutzlosen
          Produkt angefangen hab zu googeln warum das nichts bringt. Wenn man
          Geld für Zeug ausgegeben hat das gar nichts bewirkt, fängt man
          irgendwann an genauer hinzuschauen. Die Infos zur Standardisierung
          findet man mit einer einfachen Suche — steht in keiner Werbung, muss
          man sich selbst zusammensuchen.
        </p>
        <p data-id="element-221">
          Ich verdiene nichts daran. Schreib das hier weil Thomas seinen Post
          geschrieben hat und weil ich erkenne was er gerade durchmacht. Wer
          selbst nachschauen will, findet alles.
        </p>
      </>
}, {
  id: 15,
  avatar: {
    letter: 'N',
    color: 'red'
  },
  username: 'NachtfalterHH',
  role: 'Mitglied',
  stats: {
    joined: '19.11.2022',
    posts: 441
  },
  datetime: '26.04.2026, 22:03',
  content: <>
        <QuoteBlock who="Klaus_Freiburg schrieb:" data-id="element-222">
          Die Infos zur Standardisierung findet man mit einer einfachen Suche —
          steht in keiner Werbung, muss man sich selbst zusammensuchen.
        </QuoteBlock>
        <p data-id="element-223">
          Okay, hab's nachgeschaut. Stimmt — das mit der Standardisierung steht
          tatsächlich nirgendwo in der Werbung. Hab drei Produkte die ich
          zuhause hab gecheckt. Zwei davon haben gar keine Angabe, eines hat
          22%.
        </p>
        <p data-id="element-224">
          Klaus, ich nehm das zurück. Du weißt offensichtlich wovon du redest.
          Ob das Produkt selbst was taugt weiß ich nicht — aber die Kriterien
          die du nennst klingen nicht erfunden.
        </p>
        <p data-id="element-225">
          Thomas, ich hoffe du findest was das hilft. Der Post hat mich auch
          erwischt, ehrlich gesagt.
        </p>
      </>
}, {
  id: 16,
  avatar: {
    letter: 'T',
    color: 'blue'
  },
  username: 'Typ_aus_Sonneberg',
  role: 'Mitglied',
  stats: {
    joined: '14.07.2019',
    posts: 203
  },
  datetime: '27.04.2026, 07:52',
  content: <>
        <p data-id="element-226">Danke euch allen. Wirklich.</p>
        <p data-id="element-227">
          Klaus, ich hab heute Nacht zum ersten Mal seit Langem das Gefühl
          gehabt dass ich eine Richtung hab. Ich schau mir das an was du
          geschrieben hast — die Standardisierung, die Formel, alles. Hab schon
          angefangen zu suchen.
        </p>
        <p data-id="element-228">
          Und NachtfalterHH — dass du's nachgeschaut hast und das hier
          schreibst, das zeigt mir dass ich nicht komplett falsch liege mit
          meinem Bauchgefühl.
        </p>
        <p data-id="element-229">Ich berichte wie's weitergeht.</p>
        <p style={{
      marginTop: '0.5rem'
    }} data-id="element-230">
          Thomas
        </p>
      </>
}, {
  id: 17,
  avatar: {
    letter: 'S',
    color: 'teal'
  },
  username: 'Stahlwerk_Kai',
  role: 'Mitglied',
  stats: {
    joined: '11.03.2020',
    posts: 31
  },
  datetime: '27.04.2026, 09:17',
  content: <>
        <p data-id="element-231">
          Ich bin 46, Schichtarbeiter, Frühschicht um 5. Steh also sowieso früh
          auf — aber davor noch zweimal. Ich weiß gar nicht mehr wie es sich
          anfühlt ausgeruht zur Arbeit zu kommen.
        </p>
        <p data-id="element-232">
          Was mich wirklich beschäftigt: Konzentration an der Maschine. Das ist
          kein Spaß wenn man an schwerem Gerät arbeitet. Ich sag das niemandem —
          aber ich hab Angst dass mir irgendwann was passiert weil ich einfach
          zu müde bin.
        </p>
        <p data-id="element-233">
          Danke Thomas dass du das geschrieben hast. Ich hab diesen Thread jetzt
          zweimal gelesen.
        </p>
      </>
}, {
  id: 18,
  avatar: {
    letter: 'M',
    color: 'brown'
  },
  username: 'MorgengrauerHH',
  role: 'Mitglied',
  stats: {
    joined: '28.09.2023',
    posts: 12
  },
  datetime: '27.04.2026, 10:03',
  content: <>
        <p data-id="element-234">Erstes Mal hier in so einem Forum überhaupt. Bin 48.</p>
        <p data-id="element-235">
          Meine Frau meint ich soll zum Arzt. Ich geh nicht — weil ich Angst hab
          was zu hören. Ich weiß dass das blöd klingt. Aber solange ich nicht
          weiß was es ist, kann ich so tun als wäre es nichts.
        </p>
        <p data-id="element-236">
          Letzten Monat hab ich einen alten Freund angerufen nach Jahren —
          einfach weil ich reden musste. Er hat gefragt ob alles okay ist. Ich
          hab gesagt ja, alles gut. War nicht wahr.
        </p>
      </>
}, {
  id: 19,
  avatar: {
    letter: 'D',
    color: 'purple'
  },
  username: 'Dachziegel_Rüdiger',
  role: 'Mitglied',
  stats: {
    joined: '14.06.2021',
    posts: 44
  },
  datetime: '27.04.2026, 11:29',
  content: <>
        <p data-id="element-237">
          46, seit anderthalb Jahren so. Hab das lange als
          Einschlafschwierigkeiten abgetan — Stress, Job, alles mögliche. Aber
          der Stress ist weg und das Aufstehen ist geblieben.
        </p>
        <p data-id="element-238">
          Ich erkenn mich bei Thomas wieder mit dem Part über die Frau. Nicht
          dass ich es aussprechen würde. Aber man merkt halt Dinge. Und man weiß
          nicht ob man überreagiert oder ob da was ist.
        </p>
        <p data-id="element-239">
          Dieser Thread ist das Ehrlichste was ich seit Jahren zu dem Thema
          gelesen hab.
        </p>
      </>
}, {
  id: 20,
  avatar: {
    letter: 'V',
    color: 'gray'
  },
  username: 'Vollgas_Volker',
  role: 'Mitglied',
  stats: {
    joined: '02.11.2022',
    posts: 67
  },
  datetime: '27.04.2026, 13:44',
  content: <>
        <p data-id="element-240">47 hier. Hab den ganzen Thread gelesen, von Anfang bis Ende.</p>
        <p data-id="element-241">
          Bei mir ist das seit ca. einem Jahr so. Ich hab's meiner Frau
          verschwiegen. Warum — weiß ich selbst nicht genau. Schämt man sich
          irgendwie. Als ob das was über einen aussagt als Mann.
        </p>
        <p data-id="element-242">
          Thomas, Klaus — danke. Ich glaub ich muss endlich anfangen
          hinzuschauen statt wegzugucken.
        </p>
      </>
}, {
  id: 21,
  avatar: {
    letter: 'L',
    color: 'green'
  },
  username: 'Leisetreter_NRW',
  role: 'Mitglied',
  stats: {
    joined: '07.04.2024',
    posts: 8
  },
  datetime: '27.04.2026, 15:11',
  content: <>
        <p data-id="element-243">
          Ich hab diesen Post meiner Frau gezeigt — also den von Thomas. Sie hat
          ihn gelesen und dann mich angeschaut und nichts gesagt. Das hat mehr
          gesagt als alles was sie sagen hätte können.
        </p>
        <p data-id="element-244">
          45 Jahre alt. Seit einem Jahr so. Ich dachte es liegt am Kaffee, am
          Bier, am Stress. Jetzt bin ich mir nicht mehr so sicher.
        </p>
      </>
}, {
  id: 22,
  avatar: {
    letter: 'R',
    color: 'blue'
  },
  username: 'Ruhepuls_Markus',
  role: 'Mitglied',
  stats: {
    joined: '19.08.2021',
    posts: 103
  },
  datetime: '27.04.2026, 18:36',
  content: <>
        <p data-id="element-245">
          48 Jahre, seit zwei Jahren aufstehen. Hab heute meinen Hausarzt
          angerufen und einen Termin gemacht. Wäre ohne diesen Thread
          wahrscheinlich noch Monate so weitergegangen.
        </p>
        <p data-id="element-246">
          Manchmal braucht man einfach Männer die dasselbe durchmachen und
          trotzdem drüber reden. Danke an alle hier.
        </p>
      </>
}];